import { Dropdown, Flex, SearchIcon } from "@fluentui/react-northstar";
import styled from "styled-components";
import { DEVICE } from "../../../constants/responsive";
import useGlobalSearchEmployee from "../hooks/useGlobalSearchEmployee";

const SearchBarFromDashboard = () => {
    const { query, states, functions } = useGlobalSearchEmployee();

    return (
        <Flex>
            <DropdownStyled
                fluid
                search={(itemList) => itemList}
                items={states.items}
                searchQuery={states.searchQuery}
                placeholder="Rechercher des personnes"
                loading={query.isLoading || query.isFetching}
                loadingMessage="Chargement..."
                noResultsMessage="Aucun résultat trouvé."
                a11ySelectedItemsMessage="Press Delete or Backspace to remove"
                inverted
                clearable
                toggleIndicator={<SearchIcon />}
                onSearchQueryChange={(e, { searchQuery }) =>
                    functions.handleSearchQueryChange(searchQuery)
                }
                onBlur={functions.handleBlur}
                onChange={functions.onClickItem}
            />
        </Flex>
    );
};

export default SearchBarFromDashboard;

const DropdownStyled = styled(Dropdown)`
    @media ${DEVICE.mobileS} {
        width: 120px;
    }
    @media ${DEVICE.tablet} {
        min-width: 350px;
    }
    @media ${DEVICE.laptop} {
        min-width: 624px;
    }
`;
